import React from 'react';
import { CenterProps } from './centerProps';

const Center = ({ children, inheritHeight = true, inheritWidth = true }: CenterProps) => {
  return (
    <div
      className={`flex flex-col justify-center items-center
      ${inheritWidth ? 'w-full' : ''} 
      ${inheritHeight ? 'h-full' : ''}
      `}
    >
      {children}
    </div>
  );
};

export default Center;
